import styled from "styled-components"
import LoadInView from "../common/LoadInView"
import { TableWrapper, Table} from "../common/Table"

interface profileType {
  lv2: string
  lv4: string
  section: string
  item: string
  description: string
  imp: string
}

type propsType = {
  data: any
}

const ViewAllProfile = (props: propsType) => {

  return (
    <div>
      <LoadInView>
        <TableWrapper>
          {props.data?
          <Total>총 : <b>{props.data.length}</b>개</Total>
          :<Total>총 : <b></b>개</Total>
          }
          <Table>
            <colgroup>
              <col width="5%"/>
              <col width="7.5%"/>
              <col width="7.5%"/>
              <col width="10%"/>
              <col width="7.5%"/>
              <col width="12.5%"/>
              <col width="30%"/>
            </colgroup>
            <thead>
              <tr>
                <th>No.</th>
                <th>계열</th>
                <th>학과</th>
                <th>영역</th>
                <th>중요항목</th>
                <th>항목</th>
                <th>설명</th>
              </tr>
            </thead>
            <tbody>
              {props.data?.map((knowledge: profileType, index: number) => (
                <tr key={index}>
                  <td key={index}>{index+1}</td>
                  <td key={knowledge.lv2}>{knowledge.lv2}</td>
                  <td key={knowledge.lv4}>{knowledge.lv4}</td>
                  <td key={knowledge.section}>{knowledge.section}</td>
                  <td key={knowledge.imp}>{knowledge.imp}</td>
                  <td key={knowledge.item}>{knowledge.item}</td>
                  <td key={knowledge.description}>{knowledge.description}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      </LoadInView>
    </div>
  )
}

export default ViewAllProfile


const Total = styled.div`
  text-align: right;
  font-size: 14px;
  max-width: 80%;
`